module.exports = __webpack_public_path__ + "assets/img/hud-dd55873d.png";